// extracted by mini-css-extract-plugin
export default {"notification":"MeetingTip_notification__S7iCS"};